export const blockIconsToggleCheckBox = (
	<span className='material-symbols-outlined'>check_box</span>
);
